import { render } from "./ISPProviderPage.vue?vue&type=template&id=9fe262a8&ts=true"
import script from "./ISPProviderPage.vue?vue&type=script&lang=ts"
export * from "./ISPProviderPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__